import { memo } from 'react';
import { Tab as RACTab, TabProps as RACTabProps } from 'react-aria-components';

import { merge } from '@/components';

export type TabProps = RACTabProps;

const ITab = ({ className, children, ...rest }: TabProps) => {
  const styles = [
    'border',
    'border-gray-200',
    'cursor-pointer',
    'data-[selected]:bg-gray-50',
    'flex',
    'gap-sm',
    'group/tab',
    'hover:bg-gray-50',
    'items-center',
    'outline-none',
    'p-xs',
    'rounded-lg',

    /* Model tab*/
    'group-[*]/model-panel:bg-transparent',
    'group-[*]/model-panel:rounded-none',
    'group-[*]/model-panel:border-0',
    'group-[*]/model-panel:text-gray-500',
    'group-[*]/model-panel:text-md',
    'group-[*]/model-panel:font-normal',
    'group-[*]/model-panel:data-[selected]:border-b-2',
    'group-[*]/model-panel:data-[selected]:border-gray-600',
    'group-[*]/model-panel:data-[selected]:text-gray-800',
    'group-[*]/model-panel:grow-0',
    'group-[*]/model-panel:py-sm',
    'group-[*]/model-panel:px-sm',
    'group-[*]/model-panel:-mb-[0.1rem]',
    'group-[*]/model-panel:mr-sm',
  ];

  return (
    <RACTab className={merge(styles, className)} {...rest}>
      {children}
    </RACTab>
  );
};

export const Tab = memo(ITab) as typeof ITab;
